module.exports = __webpack_public_path__ + "img/Unidad-19.f58b2c2d.png";